import React from "react";
import Tab from "react-bootstrap/Tab";
import Heading from "../Heading/Heading";
import SingleProject from "../SingleProject/SingleProject";
import "./Projects.css";

const Projects = (props) => {
  return (
    <section id="projects" className="mt-3">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <Heading title1="Portfolio" title2="My Projects" />
          </div>
        </div>
        <div className="b-tab mt-4">
          <Tab.Container id="left-tabs-example" defaultActiveKey="Latest">
            <SingleProject />
          </Tab.Container>
        </div>
      </div>
    </section>
  );
};

export default Projects;
